import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'NiboCNPJ' })
export class CNPJFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      // Remove any non-numeric characters
      const cnpj = value.replace(/\D/g, '');
      
      // Check if it has the expected CNPJ length
      if (cnpj.length === 14) {
        // Format: XX.XXX.XXX/XXXX-XX
        return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      
      return value; // Return original value if not properly formatted
    }

    return null;
  }
}
